import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';

@Component({
    selector: 'app-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements OnInit {
    @Input() accordionData: {
        allHeaders: {
            headerText: string,
            id: number | string,
            dataForTemplate: any,
            editHeaderText: boolean,
            opened?:boolean
        }[],
        templateAccordionBody: TemplateRef<any>
    };

    @Output() emitEditHeaderName: EventEmitter<{ newName: string, id: any }> = new EventEmitter<{
        newName: string,
        id: any
    }>();

    constructor() {
    }

    ngOnInit(): void {
    }

    saveHeaderName(newName: string, id: any): void {
        this.accordionData.allHeaders.find(x => x.id === id).headerText = newName;
        const emitData = {newName, id};
        this.emitEditHeaderName.emit(emitData);
    }
}
